import styled from "@emotion/styled"
import React from "react"
import IconMail from "./images/icon-mail"


const WrapperMailContact = styled.div`
  width: 100%;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #525050;
`

const TextMailContactContainer = styled.div`
  padding: 20px 40px;
  max-width: 487px;
`

const Question = styled.h1`
  color: #ffffff;
  text-align: center;
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 38.4px;
  letter-spacing: 1.2px;
  @media (max-width: 580px) {
    font-size: 18px;
    max-width: 265px;
  }
`

const MailContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const Mail = styled.a`
  color: #ffffff;
  margin-left: 10px;
  text-decoration: none;
`


const MailContact = () => (
  <WrapperMailContact>
    <TextMailContactContainer>
      <Question>
        ¿Tienes más preguntas?
        No dudes en contactarnos
      </Question>
      <MailContainer>
        <IconMail />
        <Mail href="mailto:hola@capitaria.com">hola@capitaria.com</Mail>
      </MailContainer>
    </TextMailContactContainer>
  </WrapperMailContact>
)

export default MailContact
